import { getApplicationListForClass } from "@/api/agency/agency";

export default {

  data() {
    return {
      select_application_list: [],
    }
  },

  created() {
    if(!this.classId){
      this.loadApplicationListForSelect()
    }
  },

  methods: {
    loadApplicationListForSelect() {
      let params = {}
      params.class_level = this.formData.class_level;
      if(this.classId) {
        params.c_id = this.classId;
      }
      getApplicationListForClass(params)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return
          }
          this.select_application_list = data.result.data
        })
        .catch(err => {
          console.error('err', err)
        })
    },
  },
}

